<template>
  <button class="btn btn-primary w-100 mb-2" @click.prevent="confirmModal">{{ buttonText }}</button>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      hideModal: "hideModal",
      setShoppingListsVisibility: "shoppingList/setShoppingListsVisibility",
    }),
    confirmModal() {
      this.setShoppingListsVisibility(true);
      this.hideModal("shoppingListModal");
    },
  },
};
</script>
